module.exports = __webpack_public_path__ + "img/cimb_bank.95faf95c.png";